import React, { useState } from "react";

const FinancialAidViewer = ({
  data,
  columnKeys,
  handleEdit,
  handleSave,
  canEdit = false,
}) => {
  const [imageViewer, setImageViewer] = useState({ open: false, image: null });

  const handleImageView = (image) => {
    setImageViewer({ open: true, image });
  };

  const closeImageViewer = () => {
    setImageViewer({ open: false, image: null });
  };

  return (
    <div style={{ overflowX: "auto", width: "90%", margin: "auto" }}>
      <table
        border="1"
        style={{
          tableLayout: "fixed",
          width: "100%",
          background: "#ffffff",
          borderCollapse: "separate",
          borderSpacing: 0,
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                background: "#d5d1fd", // purple shade
                color: "#000",
                fontWeight: "600",
                padding: "14px",
                textAlign: "center",
                letterSpacing: "0.5px",
                fontSize: "14px",
                borderBottom: "1px solid #e6e6e6",
              }}
            >
              Field
            </th>
            <th
              style={{
                background: "#d5d1fd", // purple shade
                color: "#000",
                fontWeight: "600",
                padding: "14px",
                textAlign: "center",
                letterSpacing: "0.5px",
                fontSize: "14px",
                borderBottom: "1px solid #e6e6e6",
              }}
            >
              Value
            </th>
          </tr>
        </thead>
        <tbody>
          {columnKeys.map((key) => (
            <tr key={key}>
              <td>{key.toUpperCase()}</td>
              <td>
                {key === "userId" || key === "email" ? (
                  data[key]
                ) : key.toLowerCase().includes("picture") ||
                  key.toLowerCase().includes("image") ||
                  key.toLowerCase().includes("bank") ? (
                  <button
                    onClick={() => handleImageView(data[key])}
                    style={{
                      padding: "5px 10px",
                      color: "#FFF",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      backgroundColor: "#d5d1fd",
                      borderColor: "#d5d1fd",
                    }}
                    className="btn btn-primary"
                  >
                    View
                  </button>
                ) : (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="text"
                      value={data[key] || ""}
                      onChange={(e) =>
                        canEdit && handleEdit(key, e.target.value)
                      }
                      readOnly={!canEdit}
                      style={{
                        width: "100%",
                        border: "none",
                        outline: "none",
                        background: "transparent",
                      }}
                    />
                    {canEdit && (
                      <button
                        onClick={() => handleSave(data.userId, key, data[key])}
                        style={{
                          backgroundColor: "#d5d1fd",
                          borderColor: "#d5d1fd",
                          marginLeft: "10px",
                        }}
                        className="btn btn-primary"
                      >
                        Save
                      </button>
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {imageViewer.open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#FFF",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
          >
            <img
              src={
                imageViewer.image ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSIxFqi0YoJt1qdxV5wUgeJjLPA8aDW9N83QA&s"
              }
              alt="Viewer"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "5px",
                display: "block",
              }}
            />
            <button
              onClick={closeImageViewer}
              style={{
                marginTop: "15px",
                padding: "5px 15px",
                backgroundColor: "#d5d1fd",
                borderColor: "#d5d1fd",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinancialAidViewer;
